import { _ as _objectSpread2 } from './objectSpread2-811c5212.esm.js';
import { useBaseSlider, useControlsContainer, PlaybackDisplayErrorType, useFullscreenButton, usePlayButton, useProgress, useTimeDisplay, useVolume, usePlayer } from '@livepeer/core-react/components';
import * as React from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { u as useMediaController, a as useTheme, b as MediaControllerContext, M as MediaControllerProvider } from './useTheme-7521bb32.esm.js';
import { styling } from 'livepeer/media/browser/styling';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.regexp.to-string.js';
import { isPictureInPictureSupported, canPlayMediaNatively, addMediaMetricsToInitializedStore } from 'livepeer/media/browser';
import { isHlsSupported, createNewHls } from 'livepeer/media/browser/hls';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.array.index-of.js';
import { omit } from 'livepeer';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var UPDATE_FREQUENCY_MS = 50;
var mediaControllerSelector$b = function mediaControllerSelector(_ref) {
  var device = _ref.device;
  return {
    device: device
  };
};
var BaseSlider = function BaseSlider(props) {
  var _useMediaController = useMediaController(mediaControllerSelector$b),
    device = _useMediaController.device;
  var ref = React.useRef(null);
  var _React$useState = React.useState({
      width: 0,
      left: 0
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    sliderLocation = _React$useState2[0],
    setSliderLocation = _React$useState2[1];
  React.useEffect(function () {
    if (typeof window !== 'undefined') {
      var handleResize = function handleResize() {
        var _ref$current, _boundingRect$width, _boundingRect$left;
        var boundingRect = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();
        setSliderLocation({
          width: (_boundingRect$width = boundingRect === null || boundingRect === void 0 ? void 0 : boundingRect.width) !== null && _boundingRect$width !== void 0 ? _boundingRect$width : 0,
          left: (_boundingRect$left = boundingRect === null || boundingRect === void 0 ? void 0 : boundingRect.left) !== null && _boundingRect$left !== void 0 ? _boundingRect$left : 0
        });
      };
      handleResize();
      window.addEventListener('resize', handleResize);
      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }
  }, []);
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isActive = _React$useState4[0],
    setIsActive = _React$useState4[1];
  var _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    lastUpdate = _React$useState6[0],
    setLastUpdate = _React$useState6[1];
  var _useBaseSlider = useBaseSlider(_objectSpread2({
      isActive: isActive || (device === null || device === void 0 ? void 0 : device.isMobile),
      sliderWidth: sliderLocation.width,
      defaultThumbIcon: /*#__PURE__*/jsx(Thumb, {})
    }, props)),
    title = _useBaseSlider.title,
    value = _useBaseSlider.value,
    active = _useBaseSlider.active,
    handle = _useBaseSlider.handle,
    sliderProps = _useBaseSlider.sliderProps,
    sliderLeftTrackProps = _useBaseSlider.sliderLeftTrackProps,
    sliderMiddleTrackProps = _useBaseSlider.sliderMiddleTrackProps,
    sliderRightTrackProps = _useBaseSlider.sliderRightTrackProps;
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isDragging = _React$useState8[0],
    setIsDragging = _React$useState8[1];
  React.useEffect(function () {
    if (isDragging) {
      var _document, _document2, _document3, _document4;
      var onMouseMove = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
          var shouldUpdate;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  shouldUpdate = Date.now() - lastUpdate > UPDATE_FREQUENCY_MS;
                  _context.next = 3;
                  return sliderProps.onUpdate(e.clientX - sliderLocation.left, shouldUpdate);
                case 3:
                  if (shouldUpdate) {
                    setLastUpdate(Date.now());
                  }
                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function onMouseMove(_x) {
          return _ref2.apply(this, arguments);
        };
      }();
      var onTouchMove = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
          var _e$touches, _e$touches$item, _e$touches$item$call;
          var shouldUpdate, clientX;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  shouldUpdate = Date.now() - lastUpdate > UPDATE_FREQUENCY_MS;
                  clientX = (_e$touches = e.touches) === null || _e$touches === void 0 ? void 0 : (_e$touches$item = _e$touches.item) === null || _e$touches$item === void 0 ? void 0 : (_e$touches$item$call = _e$touches$item.call(_e$touches, 0)) === null || _e$touches$item$call === void 0 ? void 0 : _e$touches$item$call.clientX;
                  if (!clientX) {
                    _context2.next = 6;
                    break;
                  }
                  _context2.next = 5;
                  return sliderProps.onUpdate(clientX - sliderLocation.left, shouldUpdate);
                case 5:
                  if (shouldUpdate) {
                    setLastUpdate(Date.now());
                  }
                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return function onTouchMove(_x2) {
          return _ref3.apply(this, arguments);
        };
      }();
      var onMouseUp = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
          var _props$onDone;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  setIsDragging(false);
                  _context3.next = 3;
                  return sliderProps.onUpdate(e.clientX - sliderLocation.left, true);
                case 3:
                  _context3.next = 5;
                  return props === null || props === void 0 ? void 0 : (_props$onDone = props.onDone) === null || _props$onDone === void 0 ? void 0 : _props$onDone.call(props);
                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return function onMouseUp(_x3) {
          return _ref4.apply(this, arguments);
        };
      }();
      var onTouchEnd = /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
          var _e$touches2, _e$touches2$item, _e$touches2$item$call, _props$onDone2;
          var clientX;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  setIsDragging(false);
                  clientX = (_e$touches2 = e.touches) === null || _e$touches2 === void 0 ? void 0 : (_e$touches2$item = _e$touches2.item) === null || _e$touches2$item === void 0 ? void 0 : (_e$touches2$item$call = _e$touches2$item.call(_e$touches2, 0)) === null || _e$touches2$item$call === void 0 ? void 0 : _e$touches2$item$call.clientX;
                  if (!clientX) {
                    _context4.next = 5;
                    break;
                  }
                  _context4.next = 5;
                  return sliderProps.onUpdate(clientX - sliderLocation.left, true);
                case 5:
                  _context4.next = 7;
                  return props === null || props === void 0 ? void 0 : (_props$onDone2 = props.onDone) === null || _props$onDone2 === void 0 ? void 0 : _props$onDone2.call(props);
                case 7:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));
        return function onTouchEnd(_x4) {
          return _ref5.apply(this, arguments);
        };
      }();
      (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener('mousemove', onMouseMove);
      (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.addEventListener('mouseup', onMouseUp);
      (_document3 = document) === null || _document3 === void 0 ? void 0 : _document3.addEventListener('touchmove', onTouchMove);
      (_document4 = document) === null || _document4 === void 0 ? void 0 : _document4.addEventListener('touchend', onTouchEnd);
      // TODO handle mouse out

      return function () {
        var _document5, _document6, _document7, _document8;
        (_document5 = document) === null || _document5 === void 0 ? void 0 : _document5.removeEventListener('mousemove', onMouseMove);
        (_document6 = document) === null || _document6 === void 0 ? void 0 : _document6.removeEventListener('mouseup', onMouseUp);
        (_document7 = document) === null || _document7 === void 0 ? void 0 : _document7.removeEventListener('touchmove', onTouchMove);
        (_document8 = document) === null || _document8 === void 0 ? void 0 : _document8.removeEventListener('touchend', onTouchEnd);
      };
    }
  }, [isDragging, sliderProps, props, sliderLocation, lastUpdate]);
  var onPointerDown = React.useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return sliderProps.onUpdate(e.clientX - sliderLocation.left);
            case 2:
              setIsDragging(true);
            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return function (_x5) {
      return _ref6.apply(this, arguments);
    };
  }(), [sliderProps, sliderLocation]);
  var onMouseEnter = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            setIsActive(true);
          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  })), [setIsActive]);
  var onMouseLeave = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            setIsActive(false);
          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  })), [setIsActive]);
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    onPointerDown: onPointerDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    role: "slider",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": value,
    "aria-valuetext": title,
    "aria-orientation": "horizontal",
    className: styling.slider.container(),
    children: [sliderLeftTrackProps.shown && /*#__PURE__*/jsx("div", {
      className: styling.slider.track.left({
        size: active ? 'active' : 'default',
        rounded: sliderLeftTrackProps.rounded,
        css: sliderLeftTrackProps.css
      })
    }), handle, sliderMiddleTrackProps.shown && /*#__PURE__*/jsx("div", {
      className: styling.slider.track.middle({
        size: active ? 'active' : 'default',
        rounded: sliderMiddleTrackProps.rounded,
        css: sliderMiddleTrackProps.css
      })
    }), sliderRightTrackProps.shown && /*#__PURE__*/jsx("div", {
      className: styling.slider.track.right({
        size: active ? 'active' : 'default',
        rounded: sliderRightTrackProps.rounded,
        css: sliderRightTrackProps.css
      })
    })]
  });
};
var Thumb = function Thumb(_ref9) {
  var size = _ref9.size,
    css = _ref9.css;
  return /*#__PURE__*/jsx("div", {
    className: styling.slider.thumb({
      css: css,
      size: size
    })
  });
};

var mediaControllerSelector$a = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen;
  return {
    fullscreen: fullscreen
  };
};
var Container = function Container(props) {
  var children = props.children,
    aspectRatio = props.aspectRatio,
    theme = props.theme;

  // cast response from useTheme to string
  var className = useTheme(theme);
  var _useMediaController = useMediaController(mediaControllerSelector$a),
    fullscreen = _useMediaController.fullscreen;
  return /*#__PURE__*/jsx("div", {
    style: {
      display: 'contents'
    },
    className: className,
    children: /*#__PURE__*/jsx("div", {
      className: styling.container({
        aspectRatio: aspectRatio,
        size: fullscreen ? 'fullscreen' : 'default'
      }),
      tabIndex: 0,
      children: children
    })
  });
};

var OfflineStreamImage = function OfflineStreamImage() {
  return /*#__PURE__*/jsxs("svg", {
    viewBox: "0 0 324 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M82 8.30584L239.745 5.68359L242.335 118.151L83.9414 118.502L82 8.30584Z",
      fill: "#97F2EF"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M66 124.072L254.898 124L258 129L68.3248 128.971L66 124.072Z",
      fill: "#97F2EF"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M94.2062 111.151L92.5204 15.5292L229.556 14.1187L231.803 111.716L94.2062 111.151Z",
      fill: "#4CC38A"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M185 58.1481C185 70.8507 174.703 82 162 82C153.04 82 145.277 77.3008 141.48 70.0741C141.421 69.9609 141.362 69.8472 141.305 69.7328C140.965 69.0558 140.782 66.2859 140.704 64.963C140.278 66.2407 140.43 67.3765 140.507 67.9444C139.533 65.4642 139 62.7423 139 59.8519C139 47.1493 149.297 36 162 36C166.913 36 171.467 37.4132 175.204 39.8814C175.63 41.0012 176.226 43.6667 175.204 45.3704C176 44.8025 177.651 43.3259 177.888 41.963C182.27 45.9317 185 51.6082 185 58.1481Z",
      fill: "#141716"
    }), /*#__PURE__*/jsx("path", {
      d: "M140.704 64.963C140.278 66.2407 140.43 67.3765 140.507 67.9444C140.746 68.5556 141.013 69.1521 141.305 69.7328C140.965 69.0558 140.782 66.2859 140.704 64.963Z",
      fill: "#141716"
    }), /*#__PURE__*/jsx("path", {
      d: "M171 60.5003L156 70V60.6462V51L166.104 57.3994L171 60.5003Z",
      stroke: "#4CC38A",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M101.096 100.921L176.5 101.109M219.885 101.163L198.193 101.136",
      stroke: "#141716",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M148.197 101.161C148.197 103.28 146.472 104.998 144.344 104.998C142.215 104.998 140.49 103.28 140.49 101.161C140.49 99.042 142.215 97.3242 144.344 97.3242C146.472 97.3242 148.197 99.042 148.197 101.161Z",
      fill: "#DF0087"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M148.197 101.161C148.197 103.28 146.472 104.998 144.344 104.998C142.215 104.998 140.49 103.28 140.49 101.161C140.49 99.042 142.215 97.3242 144.344 97.3242C146.472 97.3242 148.197 99.042 148.197 101.161Z",
      stroke: "#141716",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M93.7252 111.754L91.7752 14.7408L230.275 13.7374L232.225 112.245L93.7252 111.754Z",
      stroke: "#141716",
      strokeWidth: "2.5"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M49.0868 58.0273L49.9632 88.7907L19.4093 88.9852L19.0201 58.6113L49.0868 58.0273ZM51 89.7922L50.0663 57L18 57.6228L18.4147 90L51 89.7922Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M296.114 25.1881L297.132 60.7679L261.637 60.9929L261.185 25.8636L296.114 25.1881ZM298.336 61.9263L297.252 24L260 24.7203L260.482 62.1666L298.336 61.9263Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M293.138 78.0001L293 67.2077L303.689 67.0001L304 77.9308L293.138 78.0001ZM304.309 78.2288L292.842 78.3019L292.696 66.9135L303.98 66.6943L304.309 78.2288ZM303.071 67.6482L293.644 67.8313L293.766 77.3599L303.346 77.2989L303.071 67.6482ZM303.362 67.3425L293.34 67.5372L293.47 77.6618L303.654 77.5969L303.362 67.3425Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M303.362 67.3424L303.654 77.5969L293.47 77.6617L293.34 67.5371L303.362 67.3424ZM304 77.9307L303.689 67L293 67.2076L293.138 78L304 77.9307Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M289.594 66.2179L289.78 72.7435L283.299 72.7847L283.216 66.3418L289.594 66.2179ZM290 72.9559L289.802 66L283 66.1321L283.088 73L290 72.9559Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M290.309 73.254L282.792 73.3019L282.696 65.838L290.093 65.6943L290.309 73.254ZM289.594 66.218L289.78 72.7435L283.299 72.7848L283.216 66.3419L289.594 66.218ZM289.471 72.4455L283.595 72.4829L283.52 66.636L289.303 66.5237L289.471 72.4455ZM283.088 73.0001L283 66.1322L289.802 66.0001L290 72.956L283.088 73.0001Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47.442 36.3017L47.3038 47.0941L57.9925 47.3017L58.3038 36.371L47.442 36.3017ZM58.6124 36.0729L47.1459 35.9998L47 47.3883L58.284 47.6074L58.6124 36.0729ZM57.3747 46.6536L47.9476 46.4704L48.0697 36.9419L57.6496 37.0029L57.3747 46.6536ZM57.6661 46.9593L47.6438 46.7646L47.7736 36.64L57.9582 36.7048L57.6661 46.9593Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M57.6661 46.9593L57.9582 36.7049L47.7736 36.64L47.6439 46.7646L57.6661 46.9593ZM58.3038 36.371L57.9926 47.3018L47.3038 47.0942L47.4421 36.3018L58.3038 36.371Z",
      fill: "#434545"
    })]
  });
};
var OfflineStreamImage$1 = OfflineStreamImage;

var PrivateStreamImage = function PrivateStreamImage() {
  return /*#__PURE__*/jsxs("svg", {
    viewBox: "0 0 324 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("circle", {
      cx: "162",
      cy: "76",
      r: "23",
      stroke: "#141716",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M242 88.5C242 88.5 206.183 131 162 131C117.817 131 82 88.5 82 88.5C82 88.5 117.817 46 162 46C206.183 46 242 88.5 242 88.5Z",
      fill: "#97F2EF"
    }), /*#__PURE__*/jsx("path", {
      d: "M249 82C249 82 210.825 128 162.5 128C114.175 128 74.5 82.5 74.5 82.5C74.5 82.5 114.175 32 162.5 32C219 34 249 82 249 82Z",
      fill: "#97F2EF"
    }), /*#__PURE__*/jsx("path", {
      d: "M249 82.5C249 82.5 210.049 129 162 129C113.951 129 75 82.5 75 82.5C75 82.5 113.951 36 162 36C210.049 36 249 82.5 249 82.5Z",
      fill: "#4CC38A"
    }), /*#__PURE__*/jsx("path", {
      d: "M216.5 60.8302C202.013 51.0702 182.921 42 162 42C116.713 42 80 84.5 80 84.5C80 84.5 116.713 127 162 127C207.287 127 244 84.5 244 84.5C244 84.5 240.941 80.9589 235.5 75.921",
      stroke: "#141716",
      strokeWidth: "2.5"
    }), /*#__PURE__*/jsx("path", {
      d: "M118 117.5C117 119.5 107.5 122.7 107.5 125.5M127 121.5C123.667 126.167 117 136.7 117 141.5",
      stroke: "#97F2EF",
      strokeWidth: "2.5"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M193 86C193 100.912 180.912 114 166 114C155.482 114 146.369 108.484 141.912 100C141.842 99.8672 141.773 99.7336 141.706 99.5994C141.306 98.8046 141.091 95.553 141 94C140.5 95.5 140.679 96.8333 140.769 97.5C139.626 94.5884 139 91.3932 139 88C139 73.0883 151.088 60 166 60C171.768 60 177.113 61.6589 181.5 64.5564C182 65.8709 182.7 69 181.5 71C182.434 70.3333 184.373 68.6 184.652 67C189.796 71.6589 193 78.3227 193 86Z",
      fill: "#141716"
    }), /*#__PURE__*/jsx("path", {
      d: "M141 94C140.5 95.5 140.679 96.8333 140.769 97.5C141.05 98.2174 141.363 98.9177 141.706 99.5994C141.306 98.8046 141.091 95.553 141 94Z",
      fill: "#141716"
    }), /*#__PURE__*/jsx("path", {
      d: "M170.403 79C176.754 79 182.328 84.8203 182.328 92C182.328 99.1797 177.606 105 171.254 105C167.788 105 164.552 103.266 162.328 100.523C161.871 99.9592 161.457 99.3526 161.092 98.7097C159.98 96.7509 159.328 94.4549 159.328 92C159.328 84.8203 164.051 79 170.403 79Z",
      fill: "#4CC38A"
    }), /*#__PURE__*/jsx("path", {
      d: "M70.5 43C77 48.1667 87.3 55 94.5 63M98 8C103 19.6667 113 44.8 113 52M156.5 0.5C156 12.5 158 32.5 158 32.5M223 56C231.667 50.6667 241 43 263 39",
      stroke: "#97F2EF",
      strokeWidth: "2.5"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M288.028 49.4047L287.706 29.9756L312.554 29.6019L313.278 49.28L288.028 49.4047ZM313.995 49.8165L287.339 49.9481L287 29.4461L313.232 29.0515L313.995 49.8165ZM311.118 30.7687L289.203 31.0984L289.487 48.2522L311.757 48.1424L311.118 30.7687ZM311.795 30.2184L288.497 30.5688L288.798 48.7957L312.474 48.679L311.795 30.2184Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M311.795 30.2182L312.475 48.6788L288.798 48.7955L288.497 30.5687L311.795 30.2182ZM313.278 49.2798L312.554 29.6017L287.706 29.9755L288.028 49.4045L313.278 49.2798Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      d: "M308.595 29.6018V24.201C308.595 20.224 305.371 17 301.394 17V17C297.417 17 294.193 20.224 294.193 24.201V29.6018",
      stroke: "#434545",
      strokeWidth: "2"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M31.9897 127.881L31.6802 109.168L55.6122 108.808L56.309 127.761L31.9897 127.881ZM57 128.278L31.3266 128.405L31 108.658L56.2646 108.278L57 128.278ZM54.2287 109.932L33.1217 110.25L33.3951 126.771L54.8443 126.665L54.2287 109.932ZM54.8812 109.402L32.4415 109.74L32.732 127.295L55.5352 127.182L54.8812 109.402Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M54.8813 109.402L55.5353 127.182L32.7321 127.295L32.4416 109.74L54.8813 109.402ZM56.3091 127.761L55.6122 108.808L31.6803 109.168L31.9898 127.881L56.3091 127.761Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      d: "M51.7984 108.808V103.606C51.7984 99.776 48.6932 96.6709 44.8628 96.6709V96.6709C41.0325 96.6709 37.9273 99.776 37.9273 103.606V108.808",
      stroke: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.4568 93.4225L16.3139 85.9741L27.3595 85.8309L27.6811 93.3747L16.4568 93.4225ZM28 93.5804L16.1507 93.6308L16 85.7711L27.6606 85.6199L28 93.5804ZM26.7209 86.2782L16.9793 86.4046L17.1054 92.9807L27.005 92.9386L26.7209 86.2782ZM27.0221 86.0672L16.6653 86.2016L16.7994 93.189L27.324 93.1443L27.0221 86.0672Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.0221 86.0676L27.324 93.1447L16.7994 93.1895L16.6654 86.202L27.0221 86.0676ZM27.6811 93.3751L27.3595 85.8313L16.314 85.9746L16.4568 93.4229L27.6811 93.3751Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      d: "M25.5992 85.831V84.201C25.5992 82.4331 24.1661 81 22.3982 81V81C20.6304 81 19.1972 82.4331 19.1972 84.201V85.831",
      stroke: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M289.419 69.8179L289.288 62.3096L299.413 62.1844L299.708 69.7762L289.419 69.8179ZM300 69.9559L289.138 70L289 62.1322L299.689 62L300 69.9559ZM299 63H290L290.013 69.4319L299.088 69.3951L299 63ZM299.104 62.3909L289.61 62.5083L289.733 69.6139L299.38 69.5748L299.104 62.3909Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M299.104 62.3909L299.38 69.5748L289.733 69.6139L289.61 62.5083L299.104 62.3909ZM299.708 69.7762L299.413 62.1844L289.288 62.3096L289.419 69.8179L299.708 69.7762Z",
      fill: "#434545"
    }), /*#__PURE__*/jsx("path", {
      d: "M296.752 62.9402V61.2516C296.752 60.0081 295.744 59 294.5 59V59C293.257 59 292.249 60.0081 292.249 61.2516V62.9402",
      stroke: "#434545"
    })]
  });
};
var PrivateStreamImage$1 = PrivateStreamImage;

var OfflineStreamError = function OfflineStreamError() {
  return /*#__PURE__*/jsxs("div", {
    className: styling.controlsContainer.error.background(),
    children: [/*#__PURE__*/jsx(OfflineStreamImage$1, {}), /*#__PURE__*/jsx("div", {
      className: styling.controlsContainer.error.title(),
      children: "Stream is offline"
    }), /*#__PURE__*/jsx("div", {
      className: styling.controlsContainer.error.text(),
      children: "Playback will start automatically once stream has started."
    })]
  });
};
var PrivateStreamError = function PrivateStreamError() {
  return /*#__PURE__*/jsxs("div", {
    className: styling.controlsContainer.error.background(),
    children: [/*#__PURE__*/jsx(PrivateStreamImage$1, {}), /*#__PURE__*/jsx("div", {
      className: styling.controlsContainer.error.title(),
      children: "Stream is private"
    }), /*#__PURE__*/jsx("div", {
      className: styling.controlsContainer.error.text(),
      children: "It looks like you don't have permission to view this content."
    })]
  });
};

var mediaControllerSelector$9 = function mediaControllerSelector(_ref) {
  var hidden = _ref.hidden,
    togglePlay = _ref.togglePlay,
    canPlay = _ref.canPlay,
    hasPlayed = _ref.hasPlayed,
    buffered = _ref.buffered;
  return {
    hidden: hidden,
    togglePlay: togglePlay,
    canPlay: canPlay,
    hasPlayed: hasPlayed,
    buffered: buffered
  };
};
var ControlsContainer = function ControlsContainer(props) {
  var top = props.top,
    middle = props.middle,
    left = props.left,
    right = props.right,
    poster = props.poster,
    _props$showLoadingSpi = props.showLoadingSpinner,
    showLoadingSpinner = _props$showLoadingSpi === void 0 ? true : _props$showLoadingSpi,
    _props$hidePosterOnPl = props.hidePosterOnPlayed,
    hidePosterOnPlayed = _props$hidePosterOnPl === void 0 ? true : _props$hidePosterOnPl,
    loadingText = props.loadingText,
    playbackDisplayErrorType = props.playbackDisplayErrorType;
  var _useMediaController = useMediaController(mediaControllerSelector$9),
    hidden = _useMediaController.hidden,
    togglePlay = _useMediaController.togglePlay,
    canPlay = _useMediaController.canPlay,
    hasPlayed = _useMediaController.hasPlayed,
    buffered = _useMediaController.buffered;
  var _useControlsContainer = useControlsContainer({
      togglePlay: togglePlay,
      canPlay: canPlay,
      buffered: buffered
    }),
    isLoaded = _useControlsContainer.isLoaded,
    containerProps = _useControlsContainer.containerProps;
  var playbackDisplayErrorComponent = React.useMemo(function () {
    switch (playbackDisplayErrorType) {
      case PlaybackDisplayErrorType.OfflineStream:
        return /*#__PURE__*/jsx(OfflineStreamError, {});
      case PlaybackDisplayErrorType.PrivateStream:
        return /*#__PURE__*/jsx(PrivateStreamError, {});
      default:
        return /*#__PURE__*/jsx(Fragment, {});
    }
  }, [playbackDisplayErrorType]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [poster ? /*#__PURE__*/jsx("div", {
      className: styling.controlsContainer.background({
        display: hasPlayed && hidePosterOnPlayed ? 'hidden' : 'shown'
      }),
      onMouseUp: containerProps.onPress,
      children: poster
    }) : /*#__PURE__*/jsx("div", {
      className: styling.controlsContainer.background({
        display: 'hidden'
      }),
      onMouseUp: containerProps.onPress
    }), showLoadingSpinner && !isLoaded && !playbackDisplayErrorType && /*#__PURE__*/jsxs("div", {
      className: styling.controlsContainer.background(),
      onMouseUp: containerProps.onPress,
      children: [loadingText && /*#__PURE__*/jsx("div", {
        className: styling.controlsContainer.loadingText(),
        children: loadingText
      }), /*#__PURE__*/jsx("div", {
        className: styling.controlsContainer.loading()
      })]
    }), playbackDisplayErrorType && /*#__PURE__*/jsx("div", {
      className: styling.controlsContainer.background(),
      onMouseUp: containerProps.onPress,
      children: playbackDisplayErrorComponent
    }), isLoaded && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("div", {
        className: styling.controlsContainer.gradient({
          display: hidden ? 'hidden' : 'shown'
        }),
        onMouseUp: containerProps.onPress
      }), /*#__PURE__*/jsx("div", {
        className: styling.controlsContainer.top.container({
          display: hidden ? 'hidden' : 'shown'
        }),
        children: top
      }), /*#__PURE__*/jsxs("div", {
        className: styling.controlsContainer.bottom.container({
          display: hidden ? 'hidden' : 'shown'
        }),
        children: [/*#__PURE__*/jsx("div", {
          className: styling.controlsContainer.bottom.middle.container(),
          children: middle
        }), /*#__PURE__*/jsxs("div", {
          className: styling.controlsContainer.bottom.lower.container(),
          children: [/*#__PURE__*/jsx("div", {
            className: styling.controlsContainer.bottom.lower.left(),
            children: left
          }), /*#__PURE__*/jsx("div", {
            className: styling.controlsContainer.bottom.lower.right(),
            children: right
          })]
        })]
      })]
    })]
  });
};

var DefaultEnterFullscreenIcon = function DefaultEnterFullscreenIcon() {
  return /*#__PURE__*/jsxs("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "m 10,16 2,0 0,-4 4,0 0,-2 L 10,10 l 0,6 0,0 z"
    }), /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "m 20,10 0,2 4,0 0,4 2,0 L 26,10 l -6,0 0,0 z"
    }), /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "m 24,24 -4,0 0,2 L 26,26 l 0,-6 -2,0 0,4 0,0 z"
    }), /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "M 12,20 10,20 10,26 l 6,0 0,-2 -4,0 0,-4 0,0 z"
    })]
  });
};
var DefaultExitFullscreenIcon = function DefaultExitFullscreenIcon() {
  return /*#__PURE__*/jsxs("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "m 14,14 -4,0 0,2 6,0 0,-6 -2,0 0,4 0,0 z"
    }), /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "m 22,14 0,-4 -2,0 0,6 6,0 0,-2 -4,0 0,0 z"
    }), /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "m 20,26 2,0 0,-4 4,0 0,-2 -6,0 0,6 0,0 z"
    }), /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "m 10,22 4,0 0,4 2,0 0,-6 -6,0 0,2 0,0 z"
    })]
  });
};
var mediaControllerSelector$8 = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen,
    pictureInPicture = _ref.pictureInPicture,
    requestToggleFullscreen = _ref.requestToggleFullscreen;
  return {
    fullscreen: fullscreen,
    pictureInPicture: pictureInPicture,
    requestToggleFullscreen: requestToggleFullscreen
  };
};
var FullscreenButton = function FullscreenButton(props) {
  var _useMediaController = useMediaController(mediaControllerSelector$8),
    fullscreen = _useMediaController.fullscreen,
    pictureInPicture = _useMediaController.pictureInPicture,
    requestToggleFullscreen = _useMediaController.requestToggleFullscreen;
  var _useFullscreenButton = useFullscreenButton(_objectSpread2({
      fullscreen: fullscreen,
      pictureInPicture: pictureInPicture,
      requestToggleFullscreen: requestToggleFullscreen,
      defaultEnterIcon: /*#__PURE__*/jsx(DefaultEnterFullscreenIcon, {}),
      defaultExitIcon: /*#__PURE__*/jsx(DefaultExitFullscreenIcon, {})
    }, props)),
    title = _useFullscreenButton.title,
    buttonProps = _useFullscreenButton.buttonProps;
  if (!buttonProps) {
    return /*#__PURE__*/jsx(Fragment, {});
  }
  return /*#__PURE__*/jsx("button", _objectSpread2(_objectSpread2({}, omit(buttonProps, 'onPress')), {}, {
    className: styling.iconButton(),
    title: title,
    "aria-label": title,
    onClick: buttonProps.onPress
  }));
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded = ["icon", "onClick"];
var DefaultPictureInPictureIcon = function DefaultPictureInPictureIcon() {
  return /*#__PURE__*/jsx("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "M25,17 L17,17 L17,23 L25,23 L25,17 L25,17 Z M29,25 L29,10.98 C29,9.88 28.1,9 27,9 L9,9 C7.9,9 7,9.88 7,10.98 L7,25 C7,26.1 7.9,27 9,27 L27,27 C28.1,27 29,26.1 29,25 L29,25 Z M27,25.02 L9,25.02 L9,10.97 L27,10.97 L27,25.02 L27,25.02 Z"
    })
  });
};
var mediaControllerSelector$7 = function mediaControllerSelector(_ref) {
  var requestTogglePictureInPicture = _ref.requestTogglePictureInPicture,
    pictureInPicture = _ref.pictureInPicture,
    _element = _ref._element,
    fullscreen = _ref.fullscreen;
  return {
    requestTogglePictureInPicture: requestTogglePictureInPicture,
    pictureInPicture: pictureInPicture,
    _element: _element,
    fullscreen: fullscreen
  };
};
var PictureInPictureButton = function PictureInPictureButton(props) {
  var _useMediaController = useMediaController(mediaControllerSelector$7),
    requestTogglePictureInPicture = _useMediaController.requestTogglePictureInPicture,
    _element = _useMediaController._element,
    pictureInPicture = _useMediaController.pictureInPicture,
    fullscreen = _useMediaController.fullscreen;
  var icon = props.icon,
    onClick = props.onClick,
    rest = _objectWithoutProperties(props, _excluded);
  var onClickComposed = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onClick === null || onClick === void 0 ? void 0 : onClick(e);
            case 2:
              _context.next = 4;
              return requestTogglePictureInPicture();
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onClick, requestTogglePictureInPicture]);
  var isPiPSupported = React.useMemo(function () {
    return isPictureInPictureSupported(_element);
  }, [_element]);
  var title = React.useMemo(function () {
    return pictureInPicture ? 'Exit mini player (i)' : 'Mini player (i)';
  }, [pictureInPicture]);

  // do not show button if it is not supported or if currently fullscreen
  if (!isPiPSupported || fullscreen) {
    return /*#__PURE__*/jsx(Fragment, {});
  }
  var _children = icon ? icon : /*#__PURE__*/jsx(DefaultPictureInPictureIcon, {});
  return /*#__PURE__*/jsx("button", _objectSpread2(_objectSpread2({}, rest), {}, {
    className: styling.iconButton(),
    title: title,
    "aria-label": title,
    onClick: onClickComposed,
    children: _children
  }));
};

var DefaultPlayIcon = function DefaultPlayIcon() {
  return /*#__PURE__*/jsx("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("path", {
      d: "M 12,26 18.5,22 18.5,14 12,10 z M 18.5,22 25,18 25,18 18.5,14 z",
      fill: "currentColor"
    })
  });
};
var DefaultPauseIcon = function DefaultPauseIcon() {
  return /*#__PURE__*/jsx("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    children: /*#__PURE__*/jsx("path", {
      d: "M 12,26 16,26 16,10 12,10 z M 21,26 25,26 25,10 21,10 z",
      fill: "currentColor"
    })
  });
};
var mediaControllerSelector$6 = function mediaControllerSelector(_ref) {
  var togglePlay = _ref.togglePlay,
    playing = _ref.playing;
  return {
    togglePlay: togglePlay,
    playing: playing
  };
};
var PlayButton = function PlayButton(props) {
  var _useMediaController = useMediaController(mediaControllerSelector$6),
    togglePlay = _useMediaController.togglePlay,
    playing = _useMediaController.playing;
  var _usePlayButton = usePlayButton(_objectSpread2({
      togglePlay: togglePlay,
      playing: playing,
      defaultPauseIcon: /*#__PURE__*/jsx(DefaultPauseIcon, {}),
      defaultPlayIcon: /*#__PURE__*/jsx(DefaultPlayIcon, {})
    }, props)),
    buttonProps = _usePlayButton.buttonProps,
    title = _usePlayButton.title;
  return /*#__PURE__*/jsx("button", _objectSpread2(_objectSpread2({}, omit(buttonProps, 'onPress')), {}, {
    className: styling.iconButton(),
    title: title,
    "aria-label": title,
    onClick: buttonProps.onPress
  }));
};

var mediaControllerSelector$5 = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen;
  return {
    fullscreen: fullscreen
  };
};
var Poster = function Poster(props) {
  var _useMediaController = useMediaController(mediaControllerSelector$5),
    fullscreen = _useMediaController.fullscreen;
  var content = props.content,
    title = props.title;
  return typeof content === 'string' ? /*#__PURE__*/jsx("img", {
    className: styling.media.poster({
      size: fullscreen ? 'fullscreen' : 'default'
    }),
    "aria-label": title,
    alt: title,
    src: content
  }) : /*#__PURE__*/React.isValidElement(content) ? /*#__PURE__*/React.cloneElement(content, {
    className: styling.media.poster({
      size: fullscreen ? 'fullscreen' : 'default'
    })
  }) : /*#__PURE__*/jsx(Fragment, {});
};

var mediaControllerSelector$4 = function mediaControllerSelector(_ref) {
  var duration = _ref.duration,
    progress = _ref.progress,
    requestSeek = _ref.requestSeek,
    buffered = _ref.buffered;
  return {
    duration: duration,
    progress: progress,
    requestSeek: requestSeek,
    buffered: buffered
  };
};
var Progress = function Progress(props) {
  var _useMediaController = useMediaController(mediaControllerSelector$4),
    duration = _useMediaController.duration,
    progress = _useMediaController.progress,
    requestSeek = _useMediaController.requestSeek,
    buffered = _useMediaController.buffered;
  var _useProgress = useProgress(_objectSpread2({
      duration: duration,
      progress: progress,
      requestSeek: requestSeek,
      buffered: buffered
    }, props)),
    progressProps = _useProgress.progressProps,
    title = _useProgress.title;
  return /*#__PURE__*/jsx(BaseSlider, _objectSpread2(_objectSpread2({}, progressProps), {}, {
    ariaName: title
  }));
};

var mediaControllerSelector$3 = function mediaControllerSelector(_ref) {
  var duration = _ref.duration,
    progress = _ref.progress,
    live = _ref.live;
  return {
    duration: duration,
    progress: progress,
    live: live
  };
};
var TimeDisplay = function TimeDisplay() {
  var _useMediaController = useMediaController(mediaControllerSelector$3),
    duration = _useMediaController.duration,
    progress = _useMediaController.progress,
    live = _useMediaController.live;
  var _useTimeDisplay = useTimeDisplay({
      duration: duration,
      progress: progress,
      live: live
    }),
    title = _useTimeDisplay.title,
    isLive = _useTimeDisplay.live;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("span", {
      className: styling.time.text(),
      "aria-label": 'Playback time',
      children: title
    }), isLive && /*#__PURE__*/jsxs("div", {
      className: styling.time.container(),
      children: [/*#__PURE__*/jsx("div", {
        className: styling.time.liveIndicator()
      }), /*#__PURE__*/jsx("span", {
        className: styling.time.text(),
        "aria-label": 'Live streaming media',
        children: "LIVE"
      })]
    })]
  });
};

var Title = function Title(props) {
  var content = props.content;
  return /*#__PURE__*/jsx("span", {
    className: styling.title(),
    "aria-label": 'Title',
    children: content
  });
};

var DefaultMutedIcon = function DefaultMutedIcon() {
  return /*#__PURE__*/jsxs("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    children: [/*#__PURE__*/jsx("path", {
      d: "M 9.25,9 7.98,10.27 24.71,27 l 1.27,-1.27 Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z M19,14 L19,22 C20.48,21.32 21.5,19.77 21.5,18 C21.5,16.26 20.48,14.74 19,14 ZM19,11.29 C21.89,12.15 24,14.83 24,18 C24,21.17 21.89,23.85 19,24.71 L19,26.77 C23.01,25.86 26,22.28 26,18 C26,13.72 23.01,10.14 19,9.23 L19,11.29 Z"
    })]
  });
};
var DefaultUnmutedIcon = function DefaultUnmutedIcon() {
  return /*#__PURE__*/jsx("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    children: /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z M19,14 L19,22 C20.48,21.32 21.5,19.77 21.5,18 C21.5,16.26 20.48,14.74 19,14 ZM19,11.29 C21.89,12.15 24,14.83 24,18 C24,21.17 21.89,23.85 19,24.71 L19,26.77 C23.01,25.86 26,22.28 26,18 C26,13.72 23.01,10.14 19,9.23 L19,11.29 Z"
    })
  });
};
var mediaControllerSelector$2 = function mediaControllerSelector(_ref) {
  var isVolumeChangeSupported = _ref.isVolumeChangeSupported,
    requestToggleMute = _ref.requestToggleMute,
    requestVolume = _ref.requestVolume,
    muted = _ref.muted,
    volume = _ref.volume;
  return {
    isVolumeChangeSupported: isVolumeChangeSupported,
    requestToggleMute: requestToggleMute,
    requestVolume: requestVolume,
    muted: muted,
    volume: volume
  };
};
var Volume = function Volume(props) {
  var _useMediaController = useMediaController(mediaControllerSelector$2),
    volume = _useMediaController.volume,
    requestToggleMute = _useMediaController.requestToggleMute,
    muted = _useMediaController.muted,
    requestVolume = _useMediaController.requestVolume,
    isVolumeChangeSupported = _useMediaController.isVolumeChangeSupported;
  var _useVolume = useVolume(_objectSpread2({
      volume: volume,
      requestToggleMute: requestToggleMute,
      muted: muted,
      requestVolume: requestVolume,
      isVolumeChangeSupported: isVolumeChangeSupported,
      defaultMutedIcon: /*#__PURE__*/jsx(DefaultMutedIcon, {}),
      defaultUnmutedIcon: /*#__PURE__*/jsx(DefaultUnmutedIcon, {})
    }, props)),
    progressProps = _useVolume.progressProps,
    buttonProps = _useVolume.buttonProps,
    title = _useVolume.title;
  return /*#__PURE__*/jsxs("div", {
    className: styling.volume.container(),
    children: [/*#__PURE__*/jsx("button", _objectSpread2({
      className: styling.iconButton(),
      title: title,
      "aria-label": title,
      onClick: buttonProps.onPress
    }, omit(buttonProps, 'onPress'))), progressProps.shown && /*#__PURE__*/jsx(BaseSlider, _objectSpread2({
      ariaName: "volume",
      value: muted ? 0 : volume
    }, progressProps))]
  });
};

var useIsElementShown = function useIsElementShown(target) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isCurrentlyShown = _React$useState2[0],
    setIsCurrentlyShown = _React$useState2[1];
  React.useEffect(function () {
    if (typeof window !== 'undefined' && target) {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
            entry = _ref2[0];
          return setIsCurrentlyShown(Boolean(entry === null || entry === void 0 ? void 0 : entry.isIntersecting));
        });
        observer.observe(target);
        return function () {
          observer.disconnect();
        };
      } else {
        // we default to currently shown on Opera and other browsers that don't support IntersectionObserver
        setIsCurrentlyShown(true);
      }
    }
  }, [target]);
  return isCurrentlyShown;
};

var mediaControllerSelector$1 = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen;
  return {
    fullscreen: fullscreen
  };
};
var AudioPlayer = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var src = _ref2.src,
    autoPlay = _ref2.autoPlay,
    title = _ref2.title,
    loop = _ref2.loop,
    muted = _ref2.muted,
    objectFit = _ref2.objectFit;
  var _useMediaController = useMediaController(mediaControllerSelector$1),
    fullscreen = _useMediaController.fullscreen;
  var filteredSources = React.useMemo(function () {
    return src.filter(function (s) {
      return (s === null || s === void 0 ? void 0 : s.mime) && canPlayMediaNatively(s);
    });
  }, [src]);
  return /*#__PURE__*/jsxs("audio", {
    className: styling.media.audio({
      size: fullscreen ? 'fullscreen' : objectFit
    }),
    loop: loop,
    "aria-label": title !== null && title !== void 0 ? title : 'Audio player',
    role: "audio",
    autoPlay: autoPlay,
    ref: ref,
    "webkit-playsinline": "true",
    playsInline: true,
    muted: muted,
    children: [filteredSources.map(function (source) {
      return /*#__PURE__*/jsx("source", {
        src: source.src,
        type: source.mime
      }, source.src);
    }), "Your browser doesn't support the HTML5 <code>audio</code> tag, or the audio format."]
  });
});
AudioPlayer.displayName = 'AudioPlayer';

var STREAM_OFFLINE_ERROR_MESSAGE = 'stream open failed';
var ACCESS_CONTROL_ERROR_MESSAGE = 'shutting down since this session is not allowed to view this stream';
var isStreamOfflineError = function isStreamOfflineError(error) {
  return error.message.toLowerCase().indexOf(STREAM_OFFLINE_ERROR_MESSAGE) !== -1;
};
var isAccessControlError = function isAccessControlError(error) {
  return error.message.toLowerCase().indexOf(ACCESS_CONTROL_ERROR_MESSAGE) !== -1;
};

var mediaControllerSelector = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen;
  return {
    fullscreen: fullscreen
  };
};
var VideoPlayer = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var src = _ref2.src,
    autoPlay = _ref2.autoPlay,
    title = _ref2.title,
    loop = _ref2.loop,
    muted = _ref2.muted,
    poster = _ref2.poster,
    objectFit = _ref2.objectFit,
    onAccessControlError = _ref2.onAccessControlError;
  var _useMediaController = useMediaController(mediaControllerSelector),
    fullscreen = _useMediaController.fullscreen;
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    filteredSources = _React$useState2[0],
    setFilteredSources = _React$useState2[1];
  React.useEffect(function () {
    setFilteredSources(src === null || src === void 0 ? void 0 : src.filter(function (s) {
      return (s === null || s === void 0 ? void 0 : s.mime) && canPlayMediaNatively(s);
    }));
  }, [src]);
  var handleError = React.useCallback(function (error) {
    if (isAccessControlError(error)) {
      onAccessControlError === null || onAccessControlError === void 0 ? void 0 : onAccessControlError(error);
    }
    console.warn(error.message);
  }, [onAccessControlError]);
  var onVideoError = React.useCallback(function (event) {
    // TODO: handleError(...)
    console.log('video error', event);
    handleError(new Error('Generic video error'));
  }, [handleError]);
  var onSourceError = React.useCallback(function (event) {
    // TODO: handleError(...)
    console.log('source error', event);
    handleError(new Error('Generic source error'));
  }, [handleError]);
  return /*#__PURE__*/jsxs("video", {
    className: styling.media.video({
      size: fullscreen ? 'fullscreen' : objectFit
    }),
    loop: loop,
    "aria-label": title !== null && title !== void 0 ? title : 'Video player',
    role: "video",
    autoPlay: autoPlay,
    width: "100%",
    height: "100%",
    ref: ref,
    "webkit-playsinline": "true",
    playsInline: true,
    muted: muted,
    poster: typeof poster === 'string' ? poster : undefined,
    onError: onVideoError,
    children: [filteredSources === null || filteredSources === void 0 ? void 0 : filteredSources.map(function (source) {
      return /*#__PURE__*/jsx("source", {
        src: source.src,
        type: source.mime,
        onError: onSourceError
      }, source.src);
    }), "Your browser doesn't support the HTML5 <code>video</code> tag, or the video format."]
  });
});
VideoPlayer.displayName = 'VideoPlayer';

var HlsPlayer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var hlsConfig = props.hlsConfig,
    src = props.src,
    autoPlay = props.autoPlay,
    title = props.title,
    loop = props.loop,
    muted = props.muted,
    poster = props.poster,
    objectFit = props.objectFit,
    onStreamStatusChange = props.onStreamStatusChange,
    onMetricsError = props.onMetricsError,
    onAccessControlError = props.onAccessControlError;
  var store = React.useContext(MediaControllerContext);
  React.useEffect(function () {
    var _addMediaMetricsToIni = addMediaMetricsToInitializedStore(store, src === null || src === void 0 ? void 0 : src.src, function (e) {
        onMetricsError === null || onMetricsError === void 0 ? void 0 : onMetricsError(e);
        console.error('Not able to report player metrics', e);
      }),
      destroy = _addMediaMetricsToIni.destroy;
    return destroy;
  }, [onMetricsError, store, src]);
  var _React$useMemo = React.useMemo(function () {
      return [isHlsSupported(), canPlayMediaNatively(_objectSpread2(_objectSpread2({}, src), {}, {
        mime: 'application/vnd.apple.mpegurl'
      }))];
    }, [src]),
    _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
    canUseHlsjs = _React$useMemo2[0],
    canPlayAppleMpeg = _React$useMemo2[1];
  React.useEffect(function () {
    var element = store.getState()._element;
    if (element && canUseHlsjs && !canPlayAppleMpeg && src.src) {
      var onLive = function onLive(fullscreen) {
        onStreamStatusChange === null || onStreamStatusChange === void 0 ? void 0 : onStreamStatusChange(true);
        store.getState().setLive(fullscreen);
      };
      var onError = function onError(error) {
        var _error$response;
        var cleanError = new Error((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data.toString());
        if (isStreamOfflineError(cleanError)) {
          onStreamStatusChange === null || onStreamStatusChange === void 0 ? void 0 : onStreamStatusChange(false);
        } else if (isAccessControlError(cleanError)) {
          onAccessControlError === null || onAccessControlError === void 0 ? void 0 : onAccessControlError(cleanError);
        }
        console.warn(cleanError.message);
      };
      var _createNewHls = createNewHls(src.src, element, {
          onLive: onLive,
          onDuration: store.getState().onDurationChange,
          onCanPlay: store.getState().onCanPlay,
          onError: onError
        }, _objectSpread2({
          autoplay: autoPlay
        }, hlsConfig)),
        destroy = _createNewHls.destroy;
      return function () {
        destroy();
      };
    }
  }, [autoPlay, hlsConfig, src, store, canUseHlsjs, canPlayAppleMpeg, onStreamStatusChange, onAccessControlError]);

  // if Media Source is supported and if HLS is not supported by default in the user's browser, use HLS.js
  // fallback to using a regular video player
  return !canPlayAppleMpeg && canUseHlsjs ? /*#__PURE__*/jsx("video", {
    className: styling.media.video({
      size: store.getState().fullscreen ? 'fullscreen' : objectFit
    }),
    loop: loop,
    "aria-label": title !== null && title !== void 0 ? title : 'Video player',
    role: "video",
    width: "100%",
    height: "100%",
    ref: ref,
    "webkit-playsinline": "true",
    playsInline: true,
    autoPlay: autoPlay,
    muted: muted,
    poster: typeof poster === 'string' ? poster : undefined
  }) : /*#__PURE__*/jsx(VideoPlayer, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    src: [_objectSpread2(_objectSpread2({}, src), {}, {
      type: 'video'
    })]
  }));
});
HlsPlayer.displayName = 'HlsPlayer';

var PlayerInternal = function PlayerInternal(props) {
  var _source$;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isCurrentlyShown = _React$useState2[0],
    setIsCurrentlyShown = _React$useState2[1];
  var _usePlayer = usePlayer(props, {
      _isCurrentlyShown: isCurrentlyShown
    }),
    mediaElement = _usePlayer.mediaElement,
    playerProps = _usePlayer.playerProps,
    controlsContainerProps = _usePlayer.controlsContainerProps,
    source = _usePlayer.source,
    _usePlayer$props = _usePlayer.props,
    children = _usePlayer$props.children,
    controls = _usePlayer$props.controls,
    theme = _usePlayer$props.theme,
    title = _usePlayer$props.title,
    poster = _usePlayer$props.poster,
    onStreamStatusChange = _usePlayer$props.onStreamStatusChange,
    onMetricsError = _usePlayer$props.onMetricsError,
    onAccessControlError = _usePlayer$props.onAccessControlError,
    showTitle = _usePlayer$props.showTitle,
    aspectRatio = _usePlayer$props.aspectRatio;
  var _isCurrentlyShown = useIsElementShown(mediaElement);
  React.useEffect(function () {
    setIsCurrentlyShown(_isCurrentlyShown);
  }, [_isCurrentlyShown]);
  return /*#__PURE__*/jsx(MediaControllerProvider, {
    element: mediaElement,
    opts: controls !== null && controls !== void 0 ? controls : {},
    children: /*#__PURE__*/jsxs(Container, {
      theme: theme,
      aspectRatio: aspectRatio,
      children: [source && !Array.isArray(source) ? /*#__PURE__*/jsx(HlsPlayer, _objectSpread2(_objectSpread2({}, playerProps), {}, {
        src: source,
        onStreamStatusChange: onStreamStatusChange,
        onMetricsError: onMetricsError,
        onAccessControlError: onAccessControlError
      })) : (source === null || source === void 0 ? void 0 : (_source$ = source[0]) === null || _source$ === void 0 ? void 0 : _source$.type) === 'audio' ? /*#__PURE__*/jsx(AudioPlayer, _objectSpread2(_objectSpread2({}, playerProps), {}, {
        src: source
        // onStreamStatusChange={onStreamStatusChange} // TODO: Add stream status change handling for audio
        // onAccessControlError={onAccessControlError} // TODO: Add access control error handling for audio
      })) : /*#__PURE__*/jsx(VideoPlayer, _objectSpread2(_objectSpread2({}, playerProps), {}, {
        src: source,
        onStreamStatusChange: onStreamStatusChange,
        onAccessControlError: onAccessControlError
      })), /*#__PURE__*/React.isValidElement(children) ? children : /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx(ControlsContainer, _objectSpread2(_objectSpread2({}, controlsContainerProps), {}, {
          poster: poster && /*#__PURE__*/jsx(Poster, {
            content: poster,
            title: title
          }),
          top: /*#__PURE__*/jsx(Fragment, {
            children: title && showTitle && /*#__PURE__*/jsx(Title, {
              content: title
            })
          }),
          middle: /*#__PURE__*/jsx(Progress, {}),
          left: /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(PlayButton, {}), /*#__PURE__*/jsx(Volume, {}), /*#__PURE__*/jsx(TimeDisplay, {})]
          }),
          right: /*#__PURE__*/jsxs(Fragment, {
            children: [props.showPipButton && /*#__PURE__*/jsx(PictureInPictureButton, {}), /*#__PURE__*/jsx(FullscreenButton, {})]
          })
        }))
      })]
    })
  });
};
var Player = /*#__PURE__*/React.memo(PlayerInternal);

export { ControlsContainer as C, FullscreenButton as F, PictureInPictureButton as P, TimeDisplay as T, Volume as V, PlayButton as a, Player as b, Poster as c, Progress as d, Title as e };
